import React from "react";
import {useTranslation} from "react-i18next";
// local
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {InfoTooltip} from "components/InfoTooltip";
import {IconPrint} from "components/icons";
import {printPage} from "helpers/helper";

const ButtonPrint = ({
  infoTooltip,
  printTitle,
  position = "absolute",
  top,
  bottom,
  right,
  left,
}) => {
  const {t} = useTranslation();

  const customStyles = {
    position,
    ...(top && {top}),
    ...(bottom && {bottom}),
    ...(right && {right}),
    ...(left && {left}),
  };

  return (
    <div className="print-button df-row-center" style={customStyles}>
      <InfoTooltip addClass="df mr-2" tooltip={infoTooltip} />
      <ButtonTransparent
        addClass="__button"
        name={t("PRINT_OR_SAVE_AS_PDF")}
        small
        icon={<IconPrint />}
        onClick={() => printPage(printTitle)}
      />
    </div>
  );
};

export default ButtonPrint;
